export default __webpack_public_path__ + "static/media/google-logo.ff2fec9b.png";